import { render } from "./ModalBody.vue?vue&type=template&id=18b54b38&scoped=true"
import script from "./ModalBody.vue?vue&type=script&lang=js"
export * from "./ModalBody.vue?vue&type=script&lang=js"

import "./ModalBody.vue?vue&type=style&index=0&id=18b54b38&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src5135303/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b54b38"]])

export default __exports__